
import { Modal, ModalCloseButton,ModalFooter, ModalOverlay, Text, ModalContent, ModalBody, Button, Input, Spacer, InputGroup, InputLeftElement } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import validator from 'validator'


const CoachPaymentModal = ({ isOpen, onClose, id , coach, onSave } : {
    isOpen : boolean,
    onClose : () => void,
    id : string,
    coach : any,
    onSave : (fixedRate : number, hourlyRate : number) => void
}) => {

    const [hourlyRate, setHourlyRate] = useState<string>("0")
    const [fixedRate, setFixedRate] = useState<string>("0")

    useEffect(() => {
        if(coach){
            setHourlyRate(coach.hourly_rate)
            setFixedRate(coach.fixed_rate)
        } else {
            setHourlyRate("0")
            setFixedRate("0")
        }
    },[id, isOpen])


    return <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
        <ModalCloseButton />
        <ModalBody p='0'>
            <Text variant='title' fontSize='2xl' fontWeight='500' mb='20px'>
                Coach Payment Settings
            </Text>

            

            <Text>Hourly Rate</Text>
            <InputGroup>
            <InputLeftElement pointerEvents='none' color='gray.400' fontSize='1.2em'>
                $
            </InputLeftElement>
                <Input
                    value={hourlyRate}
                    maxLength={4}
                    onChange={(e : any) => {
                        if (validator.isNumeric(e.target.value) || e.target.value === '') {
                            let value = e.target.value.replace(/^0+/, '');
                            setHourlyRate(value)
                        }}
                    }
             
                />
            </InputGroup>
            

            <Spacer h="10px"/>
            

            {/* <Text>Fixed Rate</Text>
            <InputGroup>
            <InputLeftElement pointerEvents='none' color='gray.400' fontSize='1.2em'>
                $
            </InputLeftElement>
                <Input
                    value={fixedRate}
                    onChange={(e : any) => {
                        if (validator.isNumeric(e.target.value) || e.target.value === '') {
                            setFixedRate(e.target.value)
                        }}
                    }
                />
            </InputGroup> */}
            
        </ModalBody>
        <ModalFooter>
            <Button variant="heavy" size='sm' 
                onClick={() => {
                    onSave((fixedRate == "") ? 0 : parseFloat(fixedRate), (hourlyRate == "") ? 0 : parseFloat(hourlyRate))
                    onClose()
                }}
            >Save</Button>
        </ModalFooter>
    </ModalContent>
</Modal>
}

export default CoachPaymentModal;